import ThemeArray from '@/components/Theme/ThemeArray';

export default class Ticket {
    get title(): string {
        return this._title;
    }
    get id(): number {
        return this._id;
    }
    private readonly _id: number;
    private readonly _title: string;
    private readonly _slug: string;
    private readonly _description: string;
    private readonly _themes: ThemeArray;

    public constructor(item: any) {
        this._id = item.id;
        this._title = item.title;
        this._slug = item.slug;
        this._description = item.description;
        this._themes = item.themes ? new ThemeArray(item.themes) : new ThemeArray();
    }

    public get num(): number {
        const array: string[] = this._title.split(' ');
        const char: string = array[array.length - 1];
        return parseInt(char);
    }

    public get themes(): ThemeArray {
        return this._themes;
    }
}
